<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="station-icon {{innerBackgroundColor}}">
    <span class="layer-1">{{cityName ? cityName : '-'}}</span>
    <span class="layer-2">{{state ? state : '-'}}</span>
    <span class="layer-3">{{divisionAbbrevation ? divisionAbbrevation : '-'}}</span>
    <span class="layer-4" *ngIf="isAllotmentVisible">{{allotment ? allotment : '0'}}</span>
    <span class="layer-5">{{mnemonic ? mnemonic : '-'}}</span>
</div>